export const state = {
  cart: {},
  count: 0,
  cartItems: [],
  totalPages: 1,
  currentPage: 1,
  combinedCartItems: [],
}
